export enum FilterTypeEnum {
  Equal = 1,
  Higher,
  HigherOrEqual,
  Lower,
  LowerOrEqual,
  Between,
  Interval,
  Like,
  List,
  MultiList
}
